import React, { useEffect, useRef } from "react";
import { BRAND_NAME } from "@/utils/constants";

import { useState } from "react";
import type { NextPage } from "next";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Layout from "../../layout/layout";
import Image from "next/image";
import subbanner from "../../assets/images/gift-banner.jpg";
import bggift from "../../assets/images/gift-card-bg-premium.png";
import giftcarddefault from "../../assets/images/gift-card-defult.png";
import logo from "../../assets/images/logo-pop-new.png";
import Anniversary from "../../assets/images/Anniversary.svg";
import diamondring from "../../assets/images/diamond-ring.svg";
import giftbannermobile from "../../assets/images/giftbannermobile.png";
import others from "../../assets/images/others.svg";
import birthday from "../../assets/images/birthday.svg";
import styles from "../../styles/giftcard.module.scss";
import { useAppDispatch, wrapper } from "@/store";
import { authActions, selectAuth } from "@/store/slices/auth";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import httpClient from "@/api/http-client";
import { phoneRegExp } from "@/utils/regex";
import endpoints from "@/api/endpoints";
import { setTitle } from "@/store/slices/helmet";
// import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Spinner } from "react-bootstrap";
// import "swiper/swiper.scss";
import SwiperGiftCard from "@/components/gift-card/swiper/swiper-slide";
import { useRouter } from "next/router";
import UploadSection from "@/components/gift-card/UploadSection";
import { unbxdCusEngTrackEvent, unbxdCusEngTrackUser } from "@/lib/unbxd";

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const GiftCard: NextPage = () => {
  const [active, setActive] = useState(["Activated"]);
  const [selectedActive, setSelectedActive] = useState("Disabled");

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploadFile, setUploadFile] = useState<any>(null);

  const [showModal2, setShowModal2] = useState(false);

  const [show, setShow] = useState(false);
  const [designList, setDesignList] = useState<any>([]);
  const [purposes, setPurposes] = useState<any>([]);

  const [templateList, setTemplateList] = useState<any>([]);
  const [preview, setPreview] = useState<any>(null);
  const [sameAs, setSameAs] = useState<any>(["new"]);
  const authState = useSelector(selectAuth);
  const [loading, setLoading] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useAppDispatch();
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [openCard, setOpenCard] = useState(0);
  const [swiperValue, setSwiperValue] = useState<any>({
    value: "",
    index: -1,
    type: "",
  });

  useEffect(() => {
    if (uploadFile) {
      const { indexFile, file, mimeType, preview: filePreview } = uploadFile;

      const newItems = [...formik.values.items];
      newItems[indexFile] = {
        ...newItems[indexFile],
        design_image_file: {
          file,
          mimeType,
          preview: filePreview,
        },
        design_image_url: filePreview, // Using preview for display
      };

      formik.setFieldValue("items", newItems);
    }
  }, [uploadFile]);
  const router = useRouter();

  const numberToArray = (n: number) => {
    return Array.from({ length: n }, (_, index) => index);
  };
  const formik = useFormik({
    initialValues: {
      items: [
        {
          purpose: "",
          // other_purpose: "",
          amount: "",
          design_image_url: "",
          template_image_url: "",
          name: "",
          email: "",
          mobile: "",
          message: "",
          show_sender_info: false,
          card_for_self: false,
          design_image_file: { file: null, mimeType: "", preview: "" },
        },
      ],
      card_no: "",
      image: "",
    },
    validationSchema: Yup.object().shape({
      items: Yup.array().of(
        Yup.object().shape({
          purpose: Yup.string().required("Please select your purpose"),
          // other_purpose: Yup.string().when("purpose", {
          //   is: (purpose: string) => purpose === "Other",
          //   then: Yup.string().required("Purpose is required"),
          //   otherwise: Yup.string(),
          // }),

          amount: Yup.number()
            .required("Please enter amount")
            .min(500, "Amount must be within 500-1,00,000")
            .max(100000, "Amount must be within 500-1,00,000")
            .test(
              "is-multiple-of-500",
              "Amount must be a multiple of 500",
              (value: any) => {
                return value % 500 === 0;
              }
            ),
          design_image_url: Yup.string().when("$index", (index, schema) => {
            return active[index] === "Activated"
              ? schema.required("Please select a template")
              : schema.notRequired();
          }),

          template_image_url: Yup.string().when("$index", (index, schema) => {
            return active[index] === "Activated"
              ? schema.required("Please select a GIF")
              : schema.notRequired();
          }),
          name: Yup.string().required("Name is required"),
          email: Yup.string()
            .required("Email is required")
            .email("Invalid email format"),
          mobile: Yup.string()
            .required("Mobile number is required")
            .matches(phoneRegExp, "Mobile number is not valid")
            .test(
              "len",
              "Mobile number needs to be exactly 10 digits",
              (val: any) => val?.toString().length === 10
            ),
          // message: Yup.string().required("Meassage is required"),
        })
      ),
      card_no: Yup.string().when("items", {
        is: (items: any) =>
          items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ) > 190000 && !authState?.user?.pan,
        then: Yup.string().required("Pan card number is required"),
        otherwise: Yup.string(),
      }),
      image: Yup.string().when("items", {
        is: (items: any) =>
          items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ) > 190000 && !authState?.user?.pan,
        then: Yup.string().required("Image is required"),
        otherwise: Yup.string(),
      }),
    }),
    onSubmit: async (values) => {
      if (!authState.user) {
        dispatch(authActions.setIsModalOpen(true));
        return;
      }
      if (!authState.user.billing_address) {
        dispatch(authActions.setBillingModalOpen(true));
        return;
      }
      for (let i = 0; i < values.items.length; i++) {
        const obj = values.items[i];
        if (
          active[i] === "Disabled" &&
          (!obj.design_image_file || !obj.design_image_file.file)
        ) {
          toast.error(`Please upload file in Gift Card ${i + 1}`);
          return;
        }
      }

      setLoading(true);
      let datas = values.items.map((obj, index) => {
        return {
          ...obj,

          design_image_url:
            active[index] !== "Disabled"
              ? purposes.find((v: any) => v.name == obj.purpose).designs[
                  obj.design_image_url
                ]
              : null,
          template_image_url:
            active[index] !== "Disabled"
              ? purposes.find((v: any) => v.name == obj.purpose).templates[
                  obj.template_image_url
                ]
              : null,
          design_image_file:
            active[index] == "Disabled"
              ? {
                  file: obj.design_image_file.file,
                  mimeType: obj.design_image_file.mimeType,
                }
              : null,
        };
      });

      try {
        if (
          values.items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ) > 190000 &&
          values.card_no
        ) {
          const formData = new FormData();
          formData.append("card_no", values.card_no);
          formData.append("image", values.image);
          await httpClient.put(endpoints.auth.update_pancard(), formData);
        }

        const { data } = await httpClient.post(
          endpoints.giftCard.purchasev2(),
          datas
        );
        // toast(data.message, {
        //   type: "success",
        //   toastId: "gift-card-success",
        // });
        unbxdCusEngTrackEvent("checkout_giftcard", {
          source: "web",
          platform: "senco",
          total_prqt: values.items.length,
          selling_amount: values.items.reduce(
            (acc: number, item: any) => acc + Number(item.amount),
            0
          ),
          discount_amt: 0,
          amount: values.items.reduce(
            (accumulator: any, currentValue: any) =>
              Number(accumulator) + Number(currentValue.amount),
            0
          ),
          user_name: authState.user?.name || "",
          user_email: authState.user?.email || "",
          user_mobile: authState.user?.mobile || "",
          items: values.items.map((item: any, index: number) => ({
            prid: `giftcard_${index}`,
            prqt: 1,
            product_name: "Gift Card",
            category: "Gift Card",
            brand: BRAND_NAME,
            amount: Number(item.amount),
            discount: 0,
          })),
        });
        if (window.smartech) {
          window.smartech(
            "identify",
            `${process.env.NEXT_PUBLIC_MOB_PREFIX}${authState.user?.mobile}`
          );
          unbxdCusEngTrackUser({
            "pk^mobile": `${process.env.NEXT_PUBLIC_MOB_PREFIX}${authState.user?.mobile}`,
            email: authState.user?.email,
            NAME: authState.user?.name,
            GENDER: authState.user?.gender,
            SENCO_USER: "yes",
          });
        }

        if (data && data.params) {
          const scriptLoaded = await loadRazorpayScript();
          if (!scriptLoaded || !window.Razorpay) {
            toast.error("Razorpay SDK failed to load");
            return;
          }
          const options = {
            key: data.params.key,
            amount: data.params.amount,
            currency: data.params.currency,
            name: data.params.name,
            description: data.params.description,
            image: data.params.image,
            order_id: data.params.order_id,
            callback_url: data.params.callback_url,
            prefill: {
              name: data.params.prefill.name,
              email: data.params.prefill.email,
              contact: data.params.prefill.contact,
            },
            notes: data.params.notes,
            theme: {
              color: "#3399cc",
            },
            handler: function (response: any) {
              // console.log(response);
              router.push(`/gift-card/status/${data.txnid}`);
            },
            modal: {
              ondismiss: async () => {
                // router.push(`/gift-card/status/${data.txnid}`);
              },
            },
          };
          if (window.Razorpay) {
            const rzp1 = new window.Razorpay(options);
            rzp1.open();
          } else {
            setLoading(false);
            toast("Razorpay SDK not available", { type: "error" });
          }
        } else {
          window.location.href = data.redirect;
        }
      } catch (error: any) {
        console.log({ error });
        if (error.response.data?.message) {
          toast(error.response.data.message, {
            type: "error",
            toastId: "gift-card-error",
          });
        } else {
          toast("Something went wrong! Try again!", {
            type: "error",
            toastId: "gift-card-error",
          });
        }
      }
      setLoading(false);
    },
  });
  const loadPurpose = async () => {
    try {
      const response = await httpClient.get(endpoints.giftCard.purpose());
      setPurposes(response.data?.data);
    } catch (error) {}
  };
  useEffect(() => {
    loadPurpose();
  }, []);
  useEffect(() => {
    if (swiperValue.index !== -1) {
      const newItems = [...formik.values.items];
      if (swiperValue.type == "gif") {
        newItems[swiperValue.index] = {
          ...newItems[swiperValue.index],
          template_image_url: swiperValue.value,
        };
      } else {
        newItems[swiperValue.index] = {
          ...newItems[swiperValue.index],
          design_image_url: swiperValue.value,
        };
      }
      formik.setFieldValue("items", newItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swiperValue]);

  return (
    <Layout>
      <div className={styles.subbanner}>
        <Image src={subbanner} alt="Gift Card banner" />
      </div>
      <div className="container-fluid">
        <div className={styles.subbannermobile}>
          <Image src={giftbannermobile} alt="Gift Card banner" />
        </div>
      </div>
      <div className={styles.bggiftmainpage}>
        <div className={styles.git_card_fill}>
          <div className="container">
            <div className={styles.heading}>
              Enter Details for Gift Card Purchase
            </div>
          </div>
        </div>
        {false && (
          <div className={`${styles.container} ${"container"}`}>
            <div className={styles.waviy}>
              <span style={{ "--i": 1 } as React.CSSProperties}>c</span>
              <span style={{ "--i": 2 } as React.CSSProperties}>o</span>
              <span style={{ "--i": 3 } as React.CSSProperties}>m</span>
              <span style={{ "--i": 4 } as React.CSSProperties}>i</span>
              <span style={{ "--i": 5 } as React.CSSProperties}>n</span>
              <span style={{ "--i": 6 } as React.CSSProperties}>g</span>
              <span style={{ "--i": 7, marginLeft: 20 } as React.CSSProperties}>
                s
              </span>
              <span style={{ "--i": 8 } as React.CSSProperties}>o</span>
              <span style={{ "--i": 9 } as React.CSSProperties}>o</span>
              <span style={{ "--i": 10 } as React.CSSProperties}>n</span>
            </div>
          </div>
        )}
        {true && (
          <form onSubmit={formik.handleSubmit}>
            <div className={styles.gift_card_main}>
              {formik.values.items.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.container} ${"container"}`}
                >
                  <div className={styles.gift_card_full}>
                    <div
                      className={styles.gift_card_header}
                      onClick={() =>
                        setOpenCard(openCard === index ? -1 : index)
                      }
                    >
                      <div className={styles.header_left}>
                        <i className="bi bi-gift"></i>
                        <span>Gift Card {index + 1}</span>
                      </div>
                      <div className={styles.header_right}>
                        {formik.values.items.length > 1 && (
                          <i
                            className="bi bi-trash me-3"
                            onClick={(e) => {
                              e.stopPropagation();
                              const data = formik.values.items.filter(
                                (_, x) => x !== index
                              );
                              setActive((prev) =>
                                prev.filter((_, i) => i !== index)
                              );
                              setOpenCard(0);
                              formik.setFieldValue("items", data);
                            }}
                            style={{ cursor: "pointer" }}
                          ></i>
                        )}
                        <i
                          className={`bi ${
                            openCard === index ? "bi-dash" : "bi-plus"
                          }`}
                        ></i>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        {openCard == index && (
                          <div className={styles.gift_card_body}>
                            <div className="row g-lg-5">
                              <div className="col-lg-6 order-2 order-lg-1">
                                <div className={styles.tabs_container}>
                                  <button
                                    type="button"
                                    className={`${styles.tab} ${
                                      active[index] === "Activated"
                                        ? styles.active
                                        : ""
                                    }`}
                                    onClick={() => {
                                      const select = [...active];
                                      select[index] = "Activated";
                                      setActive(select);

                                      const value = [...formik.values.items];
                                      if (value[index].purpose) {
                                        const purpose = purposes.find(
                                          (p: any) =>
                                            p.name === value[index].purpose
                                        );
                                        if (purpose) {
                                          value[index].template_image_url = "0";
                                          value[index].design_image_url = "0";
                                          setTemplateList((prev: any) => {
                                            const next = [...prev];
                                            next[index] = purpose.templates;
                                            return next;
                                          });
                                          setDesignList((prev: any) => {
                                            const next = [...prev];
                                            next[index] = purpose.designs;
                                            return next;
                                          });
                                        }
                                      }
                                      formik.setFieldValue("items", value);
                                    }}
                                  >
                                    Template
                                  </button>
                                  <button
                                    type="button"
                                    className={`${styles.tab} ${
                                      active[index] === "Disabled"
                                        ? styles.active
                                        : ""
                                    }`}
                                    onClick={() => {
                                      const select = [...active];
                                      select[index] = "Disabled";
                                      setActive(select);

                                      const value = [...formik.values.items];
                                      value[index].design_image_url = "";
                                      value[index].template_image_url = "";
                                      formik.setFieldValue("items", value);
                                    }}
                                  >
                                    Personalised
                                  </button>
                                </div>

                                <div className={styles.form_section}>
                                  {active[index] === "Activated" && (
                                    <>
                                      <div className={styles.purpose_grid}>
                                        {purposes.map((p: any) => (
                                          <div
                                            key={p.name}
                                            className={`${
                                              styles.purpose_item
                                            } ${
                                              item.purpose === p.name
                                                ? styles.active
                                                : ""
                                            }`}
                                            onClick={() => {
                                              const value = [
                                                ...formik.values.items,
                                              ];
                                              value[index].purpose = p.name;
                                              value[index].template_image_url =
                                                "0";
                                              value[index].design_image_url =
                                                "0";

                                              setTemplateList((prev: any) => {
                                                const next = [...prev];
                                                next[index] = p.templates;
                                                return next;
                                              });
                                              setDesignList((prev: any) => {
                                                const next = [...prev];
                                                next[index] = p.designs;
                                                return next;
                                              });

                                              formik.setFieldValue(
                                                "items",
                                                value
                                              );
                                            }}
                                          >
                                            <div
                                              className={`${styles.icon_box} ${
                                                item.purpose !== p.name
                                                  ? styles.dotted
                                                  : ""
                                              }`}
                                            >
                                              {p.name === "Anniversary" && (
                                                <Image
                                                  src={Anniversary}
                                                  alt="Anniversary"
                                                />
                                              )}
                                              {p.name === "Wedding" && (
                                                <Image
                                                  src={diamondring}
                                                  alt="diamond ring"
                                                />
                                              )}
                                              {p.name === "Birthday" && (
                                                <Image
                                                  src={birthday}
                                                  alt="Birthday"
                                                />
                                              )}
                                              {p.name !== "Anniversary" &&
                                                p.name !== "Wedding" &&
                                                p.name !== "Birthday" && (
                                                  <Image
                                                    src={others}
                                                    alt="others"
                                                  />
                                                )}
                                            </div>
                                            <span>{p.name}</span>
                                          </div>
                                        ))}
                                      </div>
                                      {!!item.purpose?.length && (
                                        <div className="mb-4">
                                          <div className="mb-3">
                                            <label className="fw-bold mb-2 small text-muted ">
                                              Select Impression
                                            </label>
                                            <SwiperGiftCard
                                              type="gif"
                                              ind={index}
                                              list={templateList[index]}
                                              swiperValue={
                                                formik.values.items[index]
                                                  .template_image_url
                                              }
                                              setswiperValue={setSwiperValue}
                                            />
                                          </div>
                                          <div>
                                            <label className="fw-bold mb-2 small text-muted ">
                                              Select Template
                                            </label>
                                            <SwiperGiftCard
                                              type="template"
                                              ind={index}
                                              list={designList[index]}
                                              swiperValue={
                                                formik.values.items[index]
                                                  .design_image_url
                                              }
                                              setswiperValue={setSwiperValue}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}

                                  {active[index] === "Disabled" && (
                                    <div className="mb-5">
                                      <div className={styles.section_title_row}>
                                        <div className={styles.section_title}>
                                          Upload Personal Image
                                        </div>
                                      </div>
                                      <UploadSection
                                        indexFile={index}
                                        setUploadFile={setUploadFile}
                                      />
                                    </div>
                                  )}

                                  <div className={styles.form_group}>
                                    <label>
                                      Enter Amount (₹500 - ₹1,00,000)
                                      <sup>*</sup>
                                    </label>
                                    <div className={styles.input_with_icon}>
                                      <i className="bi bi-currency-rupee"></i>
                                      <input
                                        type="number"
                                        placeholder="₹"
                                        {...formik.getFieldProps(
                                          `items.${index}.amount`
                                        )}
                                      />
                                    </div>
                                    <div className={styles.amount_presets}>
                                      {[1000, 2500, 5000, 10000].map((v) => (
                                        <button
                                          key={v}
                                          type="button"
                                          className={
                                            Number(item.amount) === v
                                              ? styles.active
                                              : ""
                                          }
                                          onClick={() => {
                                            const value = [
                                              ...formik.values.items,
                                            ];
                                            value[index].amount = String(v);
                                            formik.setFieldValue(
                                              "items",
                                              value
                                            );
                                          }}
                                        >
                                          ₹{v.toLocaleString()}
                                        </button>
                                      ))}
                                    </div>
                                    {formik.touched.items?.[index]?.amount &&
                                      (formik.errors.items?.[index] as any)
                                        ?.amount && (
                                        <small className="text-danger">
                                          {
                                            (
                                              formik.errors.items?.[
                                                index
                                              ] as any
                                            ).amount
                                          }
                                        </small>
                                      )}
                                  </div>

                                  <div className={styles.section_title_row}>
                                    <div className={styles.section_title}>
                                      Receiver Information
                                    </div>
                                    <div className={styles.buy_for_self_wrap}>
                                      <input
                                        type="checkbox"
                                        id={"buyForSelf" + index}
                                        checked={item.card_for_self}
                                        onChange={(e) => {
                                          if (!authState.user) {
                                            dispatch(
                                              authActions.setIsModalOpen(true)
                                            );
                                            return;
                                          }
                                          const value = [
                                            ...formik.values.items,
                                          ];
                                          value[index].card_for_self =
                                            e.target.checked;
                                          if (e.target.checked) {
                                            value[index].name =
                                              authState.user?.name || "";
                                            value[index].email =
                                              authState.user?.email || "";
                                            value[index].mobile =
                                              authState.user?.mobile || "";
                                          } else {
                                            value[index].name = "";
                                            value[index].email = "";
                                            value[index].mobile = "";
                                          }
                                          formik.setFieldValue("items", value);
                                        }}
                                      />
                                      <label htmlFor={"buyForSelf" + index}>
                                        Buy for Self
                                      </label>
                                    </div>
                                  </div>

                                  <div className={styles.form_group}>
                                    <label>
                                      Full Name<sup>*</sup>
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Enter receiver name"
                                      {...formik.getFieldProps(
                                        `items.${index}.name`
                                      )}
                                    />
                                    {formik.touched.items?.[index]?.name &&
                                      (formik.errors.items?.[index] as any)
                                        ?.name && (
                                        <small className="text-danger">
                                          {
                                            (
                                              formik.errors.items?.[
                                                index
                                              ] as any
                                            ).name
                                          }
                                        </small>
                                      )}
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className={styles.form_group}>
                                        <label>
                                          Email<sup>*</sup>
                                        </label>
                                        <input
                                          type="email"
                                          placeholder="Enter email"
                                          {...formik.getFieldProps(
                                            `items.${index}.email`
                                          )}
                                        />
                                        {formik.touched.items?.[index]?.email &&
                                          (formik.errors.items?.[index] as any)
                                            ?.email && (
                                            <small className="text-danger">
                                              {
                                                (
                                                  formik.errors.items?.[
                                                    index
                                                  ] as any
                                                ).email
                                              }
                                            </small>
                                          )}
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className={styles.form_group}>
                                        <label>
                                          Phone<sup>*</sup>
                                        </label>
                                        <input
                                          type="text"
                                          placeholder="Enter phone"
                                          {...formik.getFieldProps(
                                            `items.${index}.mobile`
                                          )}
                                        />
                                        {formik.touched.items?.[index]
                                          ?.mobile &&
                                          (formik.errors.items?.[index] as any)
                                            ?.mobile && (
                                            <small className="text-danger">
                                              {
                                                (
                                                  formik.errors.items?.[
                                                    index
                                                  ] as any
                                                ).mobile
                                              }
                                            </small>
                                          )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={styles.form_group}>
                                    <label>Special Message</label>
                                    <textarea
                                      rows={3}
                                      placeholder="Write your message here"
                                      maxLength={100}
                                      {...formik.getFieldProps(
                                        `items.${index}.message`
                                      )}
                                    />
                                    <small className="float-end text-muted mt-1">
                                      {item.message?.length || 0}/100
                                    </small>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center mt-4 w-100">
                                    <div className="form-check custom-checkbox">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={"senderInfo" + index}
                                        checked={item.show_sender_info}
                                        onChange={(e) => {
                                          if (!authState.user) {
                                            dispatch(
                                              authActions.setIsModalOpen(true)
                                            );
                                            return;
                                          }
                                          const value = [
                                            ...formik.values.items,
                                          ];
                                          value[index].show_sender_info =
                                            e.target.checked;
                                          formik.setFieldValue("items", value);
                                        }}
                                      />
                                      <label
                                        className="form-check-label fw-bold small"
                                        htmlFor={"senderInfo" + index}
                                      >
                                        Add Sender Info
                                      </label>
                                    </div>

                                    <button
                                      type="button"
                                      className={styles.add_more_btn}
                                      onClick={() => {
                                        if (formik.values.items.length < 5) {
                                          setActive([...active, "Activated"]);
                                          setOpenCard(
                                            formik.values.items.length
                                          );
                                          setSameAs([...sameAs, "new"]);
                                          formik.setFieldValue("items", [
                                            ...formik.values.items,
                                            {
                                              purpose: "",
                                              amount: "",
                                              design_image_file: {
                                                file: null,
                                                mimeType: "",
                                                preview: "",
                                              },
                                              design_image_url: "",
                                              template_image_url: "",
                                              name: "",
                                              email: "",
                                              mobile: "",
                                              message: "",
                                              show_sender_info: false,
                                              card_for_self: false,
                                            },
                                          ]);
                                        }
                                      }}
                                    >
                                      Add More Gift +
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0">
                                <div className={styles.preview_container}>
                                  <div
                                    className={`${
                                      styles.description
                                    } ${"mb-3 d-flex align-items-center gap-2  small"}`}
                                  >
                                    <i className="bi bi-cloud-arrow-up"></i>
                                    <span>Please Upload Preview</span>
                                  </div>
                                  <div className={styles.preview_card_wrapper}>
                                    {(!!String(item.design_image_url)?.length &&
                                      !!String(item.template_image_url)
                                        .length) ||
                                    !!item.design_image_file?.preview
                                      ?.length ? (
                                      active[index] === "Activated" ? (
                                        <>
                                          <Image
                                            src={
                                              purposes.find(
                                                (v: any) =>
                                                  v.name == item.purpose
                                              )?.designs[
                                                item.design_image_url
                                              ] || bggift
                                            }
                                            alt="bg gift"
                                            layout="fill"
                                            className={styles.bg_img_main_img}
                                          />
                                          <Image
                                            src={
                                              purposes.find(
                                                (v: any) =>
                                                  v.name == item.purpose
                                              )?.templates[
                                                item.template_image_url
                                              ] || ""
                                            }
                                            alt="impression gift"
                                            layout="fill"
                                            className={styles.bg_img_main_img}
                                            style={{ zIndex: 1 }}
                                            unoptimized
                                          />
                                          <div
                                            className={styles.gift_bg_overlay}
                                          >
                                            <div
                                              className={styles.premium_ribbon}
                                            >
                                              {/* <Image
                                                src={front}
                                                alt="premium ribbon"
                                                height={110}
                                                width={110}
                                              /> */}
                                            </div>
                                            <div
                                              className={
                                                styles.preview_content_overlay
                                              }
                                            >
                                              {/* {item.amount && (
                                                <div
                                                  className={
                                                    styles.premium_amount
                                                  }
                                                >
                                                  ₹
                                                  {Number(
                                                    item.amount
                                                  ).toLocaleString()}
                                                </div>
                                              )} */}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <Image
                                            src={
                                              item.design_image_file?.preview ||
                                              bggift
                                            }
                                            alt="personalised preview"
                                            layout="fill"
                                            className={styles.bg_img_main_img}
                                          />
                                          <div
                                            className={styles.gift_bg_overlay}
                                          >
                                            {/* <div
                                              className={styles.premium_ribbon}
                                            >
                                              <Image
                                                src={front}
                                                alt="premium ribbon"
                                                height={90}
                                                width={90}
                                              />
                                            </div> */}
                                            {/* <div
                                              className={
                                                styles.preview_content_overlay
                                              }
                                            >
                                              <div
                                                className={styles.premium_text}
                                              >
                                                {item.name}
                                              </div>
                                              {item.amount && (
                                                <div
                                                  className={
                                                    styles.premium_amount
                                                  }
                                                >
                                                  ₹
                                                  {Number(
                                                    item.amount
                                                  ).toLocaleString()}
                                                </div>
                                              )}
                                            </div> */}
                                          </div>
                                        </>
                                      )
                                    ) : (
                                      <div
                                        className={styles.placeholder_content}
                                      >
                                        <Image src={giftcarddefault} alt="" />
                                      </div>
                                    )}
                                  </div>

                                  <button
                                    type="button"
                                    className={styles.preview_text_wrap}
                                    onClick={() => {
                                      if (parseFloat(item.amount) > 0) {
                                        setPreview(item);
                                        setSelectedActive(active[index]);
                                        handleShow();
                                      } else {
                                        toast.error("Please enter amount");
                                      }
                                    }}
                                  >
                                    <i className="bi bi-eye"></i>
                                    Preview your Gift Card
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className={`${styles.container} ${"container"}`}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className={styles.order_summary}>
                      <div className={styles.summary_title}>Order Summary</div>

                      {formik.values.items.reduce(
                        (acc: number, curr: any) =>
                          acc + Number(curr.amount || 0),
                        0
                      ) > 190000 &&
                        !authState?.user?.pan && (
                          <div className="border rounded p-4 bg-white mb-4 shadow-sm">
                            <label className="fw-bold mb-2 text-danger">
                              PAN Card Information Required <sup>*</sup>
                            </label>
                            <p className="text-muted small mb-3">
                              PAN card is required for transactions above ₹1.9
                              lac as per regulatory requirements.
                            </p>
                            <div className="row g-3">
                              <div className="col-md-6">
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter 10-digit PAN Number"
                                  {...formik.getFieldProps("card_no")}
                                />
                                {formik.touched.card_no &&
                                formik.errors.card_no ? (
                                  <small className="text-danger">
                                    {formik.errors.card_no}
                                  </small>
                                ) : null}
                              </div>
                              <div className="col-md-6">
                                <input
                                  type="file"
                                  className="form-control d-none"
                                  accept="image/*"
                                  style={{ display: "none" }}
                                  onChange={(event) => {
                                    const file =
                                      event.currentTarget.files &&
                                      event.currentTarget.files[0];
                                    if (file)
                                      formik.setFieldValue("image", file);
                                  }}
                                />
                                {formik.touched.image && formik.errors.image ? (
                                  <small className="text-danger">
                                    {formik.errors.image}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )}

                      <div className={styles.summary_row}>
                        <div className={styles.summary_left}>
                          <div className={styles.summary_item}>
                            <div className={styles.label}>
                              Total Payble Amount
                            </div>
                            <div className={styles.value}>
                              ₹
                              {formik.values.items
                                .reduce(
                                  (acc: number, curr: any) =>
                                    acc + Number(curr.amount || 0),
                                  0
                                )
                                .toLocaleString()}
                            </div>
                          </div>
                          <div className={styles.summary_item}>
                            <div className={styles.label}>Total Gift Card</div>
                            <div className={styles.value}>
                              {formik.values.items.length}
                            </div>
                          </div>
                        </div>

                        <button
                          type="submit"
                          className={styles.proceed_btn}
                          disabled={
                            formik.values.items.reduce(
                              (acc: number, curr: any) =>
                                acc + Number(curr.amount || 0),
                              0
                            ) <= 0
                          }
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        className={styles.custom_modal_gift}
        centered
      >
        <Modal.Header className={styles.header_pop} closeButton></Modal.Header>
        <Modal.Body className="p-0">
          {preview && (
            <div className={styles.modern_preview_container}>
              <div className={styles.modern_preview_img_wrapper}>
                <Image
                  src={
                    selectedActive === "Activated"
                      ? purposes.find((v: any) => v.name == preview?.purpose)
                          ?.designs[preview?.design_image_url] || bggift
                      : preview?.design_image_file?.preview || bggift
                  }
                  alt="bg gift"
                  layout="fill"
                  objectFit="cover"
                  className={styles.modern_img}
                />
                {selectedActive === "Activated" && (
                  <Image
                    src={
                      purposes.find((v: any) => v.name == preview?.purpose)
                        ?.templates[preview?.template_image_url] || ""
                    }
                    alt="impression gift"
                    layout="fill"
                    objectFit="cover"
                    className={styles.modern_img}
                    style={{ zIndex: 1 }}
                    unoptimized
                  />
                )}
              </div>
              <div className={styles.modern_preview_content}>
                <div className={styles.modern_user_name}>{preview?.name}</div>
                {!!preview?.message?.length && (
                  <div className={styles.modern_user_msg}>
                    {preview?.message}
                  </div>
                )}
                {!!preview?.show_sender_info && (
                  <div className={styles.modern_sender_info}>
                    With Love From: <strong>{authState.user?.name}</strong>
                  </div>
                )}
              </div>
              <div className={styles.modern_preview_footer}>
                <div className={styles.modern_amount}>
                  Rs. {Number(preview?.amount || 0).toLocaleString()}
                </div>
                <div className={styles.modern_logo}>
                  <Image
                    src={logo}
                    alt="logo"
                    height={48}
                    width={140}
                    objectFit="contain"
                  />
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Layout>
  );
};
export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    store.dispatch(setTitle("Buy Gift Card"));
    return {
      props: {},
    };
  }
);

export default GiftCard;
